var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraySmPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 2,
    viewBox: "0 0 2 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Text input",
    cx: 0.571097,
    cy: 0.928519,
    r: 0.446586,
    fill: "#65676B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraySmPoint);
export default __webpack_public_path__ + "static/media/gray-sm-point.333230d163c58f6ac651a217d960302e.svg";
export { ForwardRef as ReactComponent };